/**
 * Used to apply `tailwindcss` intellisense.
 */
export function createTheme<T>(input: T) {
  return input;
}
